import gql from "graphql-tag";

export const COMPANIES = gql`
  query companies {
    companies {
      id
      name
    }
  }
`;
